export default __webpack_public_path__ + "static/media/safari_tap_review.d81fbec7.png";